export enum NotificationLevel {
  Info = 1,
  Warning = 2,
  Error = 3
}
